var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import TimeZoneWidget from '../TimeZone/TimeZoneWidget';
import PropTypes from 'prop-types';
import ClassNames from 'nucleus-widgets/lib/Date/Date.less';
import BaseWidget from 'nucleus-widgets/lib/BaseWidget';
import DateTime from 'nucleus-widgets/lib/DateTime/DateTime';
import { injectTestId, resolveTestId } from '@cvent/nucleus-test-automation';
var EventDateTimeWidget = /** @class */ (function (_super) {
    __extends(EventDateTimeWidget, _super);
    function EventDateTimeWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EventDateTimeWidget.prototype.getStyleObject = function () {
        return __assign(__assign({}, _super.prototype.getStyleObject.call(this)), { date: this.getElementInlineStyle('date'), timeTimeZone: this.getElementInlineStyle('timeTimeZone') });
    };
    EventDateTimeWidget.prototype.render = function () {
        var _a = this.props, switchTimeZone = _a.switchTimeZone, classes = _a.classes, config = _a.config, startDate = _a.startDate, endDate = _a.endDate, timeZone = _a.timeZone, translateTime = _a.translateTime, translateDate = _a.translateDate, translate = _a.translate;
        var displayFormat = config.displayDateOption;
        var styleObject = this.getStyleObject();
        var internalContainerStyle = {
            backgroundColor: 'transparent',
            borderRadius: 0,
            flex: '1 1 auto',
            paddingBottom: 5,
            paddingLeft: 15,
            paddingRight: 15,
            paddingTop: 15,
            pointerEvents: 'none'
        };
        var timeZoneContainer = {
            backgroundColor: 'transparent',
            borderRadius: 0,
            flex: '1 1 auto',
            paddingLeft: 15
        };
        var internalStyleObject = __assign(__assign({}, styleObject), { container: internalContainerStyle });
        return (React.createElement("div", { style: styleObject.container },
            React.createElement(DateTime, __assign({}, resolveTestId(this.props), { startDate: startDate, endDate: endDate, timeZone: timeZone, displayFormat: displayFormat, translate: translate, translateDate: translateDate, translateTime: translateTime, classes: classes, style: internalStyleObject })),
            React.createElement("div", __assign({ style: timeZoneContainer }, injectTestId('timeZoneWidgetContainer')),
                React.createElement(TimeZoneWidget, { instructionalTextStyles: "timeTimeZone", switchTimeZone: switchTimeZone, classes: classes, style: styleObject, widgetName: "eventDateTime" }))));
    };
    EventDateTimeWidget.propTypes = {
        type: PropTypes.string,
        config: PropTypes.shape({
            displayDateOption: PropTypes.string
        }),
        switchTimeZone: PropTypes.func,
        classes: PropTypes.any,
        style: PropTypes.any,
        translate: PropTypes.func.isRequired,
        // Non-configurable appData props.
        startDate: PropTypes.string.isRequired,
        endDate: PropTypes.string,
        timeZone: PropTypes.string.isRequired,
        translateDate: PropTypes.func.isRequired,
        translateTime: PropTypes.func.isRequired
    };
    EventDateTimeWidget.defaultProps = {
        classes: ClassNames
    };
    return EventDateTimeWidget;
}(BaseWidget));
export default EventDateTimeWidget;
